import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { Token } from '@/domain/types/Token'
import { HorizontalScroll } from '@/ui/atoms/horizontal-scroll/HorizontalScroll'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'

export interface TransactionOverviewTokenAmountOutcomeProps {
  token: Token
  amount: NormalizedNumber
  postFix?: string
  showUsdValue?: boolean
  amountDataTestId?: string
  usdValueDataTestId?: string
}

export function TransactionOverviewTokenAmountOutcome({
  token,
  amount,
  postFix,
  showUsdValue,
  amountDataTestId,
  usdValueDataTestId,
}: TransactionOverviewTokenAmountOutcomeProps) {
  const formattedAmount = token.format(amount, { style: 'auto' })
  return (
    <HorizontalScroll>
      <div className="flex w-fit items-center gap-1.5">
        <TokenIcon token={token} className="h-4 w-4" />
        <div className="flex items-baseline gap-1">
          <div className="typography-label-2 text-primary" data-testid={amountDataTestId}>
            {formattedAmount}
          </div>
          {showUsdValue && (
            <div className="typography-body-4 text-secondary" data-testid={usdValueDataTestId}>
              {token.formatUSD(amount)}
            </div>
          )}
          {postFix && <div className="typography-body-4 text-secondary">{postFix}</div>}
        </div>
      </div>
    </HorizontalScroll>
  )
}
